module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach1",
      "title": "Chapter 1: Seafood"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("SEAFOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "bro"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ISH AND RICE")])]), _vm._v(" is the traditional meat and potatoes of a Filipino diet. A nation of 7,641 islands spread over waters that partly make up the Coral Triangle, the Philippines is endowed with a rich assortment and concentration of marine life. Naturally, many of the varieties of seafood used in Philippine kitchens—such as bangus (milkfish), lapu-lapu (grouper), and suaje (endeavor prawn)—are indigenous to its geographic location and may be difficult to find in other parts of the world. The dishes in this chapter, however, demonstrate the resilience of the cuisine and the people who prepare it. Without sacrificing its hallmark Filipino flavors, each recipe is adapted to use the freshest fish, shellfish, and ingredients that are likely to be found in your area. It is equally worth mentioning that the cooking techniques here are not exclusive to seafood and will work just as well with other types of protein. Even kinilaw, a raw fish preparation, can be made with meat, but with the addition of subjecting the meat to heat before curing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d3a28c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001.vue
// module id = 87
// module chunks = 0